<template>
    <div>
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
          上刊素材
        </van-divider>
        <van-row v-if="currDeviceDemand.taskitemFileVOList"  class="text-center">
            <van-col span="8" v-for="(item,index) in currDeviceDemand.taskitemFileVOList" :key="index">
                <van-image @click="handleImgPreview(currDeviceDemand.taskitemFileVOList, index)" lazy-load width="100" height="70" fit="cover" :src="item.fileKey+ '?x-oss-process=image/resize,w_100'" />
            </van-col>
        </van-row>

        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
          施工反馈
        </van-divider>
        <van-row v-if="currDeviceDemand.attachVOList" class="text-center">
            <template v-if="currDeviceDemand.attachVOList.length>0">
              <van-col span="8" v-for="(item,index) in currDeviceDemand.attachVOList" :key="index">
                  <van-image @click="handleImgPreview(currDeviceDemand.attachVOList, index)" lazy-load width="100" height="70" fit="cover" :src="item.fileKey+ '?x-oss-process=image/resize,w_100'" />
                  <p>{{item.uploadTime}}</p>
              </van-col>
            </template>
            <van-col v-else span="24">
                暂无
            </van-col>
        </van-row>

        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0' }">
          监播情况
        </van-divider>
        <van-row v-if="currDeviceDemand.inpectAttachVOList" class="text-center">
          <template v-if="currDeviceDemand.inpectAttachVOList.length>0">
            <van-col span="8" v-for="(item,index) in currDeviceDemand.inpectAttachVOList" :key="index">
                <van-image @click="handleImgPreview(currDeviceDemand.inpectAttachVOList, index)" lazy-load width="100" height="70" fit="cover" :src="item.fileKey+ '?x-oss-process=image/resize,w_100'" />
                <p>{{item.uploadTime}}</p>
            </van-col>
          </template>
          <van-col v-else span="24">
              暂无
          </van-col>
        </van-row>
    </div>
</template>

<script>
import '@vant/touch-emulator' // 用于解决web端模拟移动端的触摸事件
import { Col, Row, Image as VanImage, ImagePreview, Divider, Button } from 'vant'

export default {
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [VanImage.name]: VanImage,
    [Divider.name]: Divider,
    [Button.name]: Button

  },
  data () {
    return ({
      currDeviceDemand: {}
    })
  },
  methods: {
    initDemandData (demandData) {
      this.currDeviceDemand = demandData
    },
    handleImgPreview (imgs, index) {
      ImagePreview({
        images: imgs.map(x => x.fileKey),
        startPosition: index,
        closeable: true
      })
    }
  }
}
</script>
